<p-dialog
  header="Vacaciones"
  [(visible)]="visible"
  [modal]="true"
  (onHide)="closeDialog()"
  [closable]="true"
  [style]="{ width: '30%' }"
  class="update-state-modal"
>
  <div class="loading-spinner" *ngIf="isLoading">
    <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
  </div>
  <div class="content-container" *ngIf="!isLoading">
    <!-- Estado de la solicitud -->
    <div class="progress-bar">
      <div class="line-background"></div>
      <div
        class="line-active"
        [style.width.%]="
          status === 'aprobado' || status === 'rechazado'
            ? ((currentStep - 1) / (steps.length - 1)) * 99
            : (currentStep / (steps.length - 1)) * 99
        "
        [ngClass]="{
          'line-accepted': status === 'aprobado',
          'line-rejected': status === 'rechazado'
        }"
      ></div>

      <div *ngFor="let item of visibleSteps; let i = index" class="step">
        <div class="circle-container">
          <div
            class="circle"
            [ngClass]="{
              active:
                i < currentStep ||
                (status === 'rechazado' && i < currentStep - 1),
              accepted: status === 'aprobado',
              rejected: i === currentStep - 1 && status === 'rechazado'
            }"
          ></div>
        </div>

        <div class="label">
          {{
            status === "aprobado" && i === 3
              ? ""
              : i === 2 && status === "rechazado"
              ? "Rechazado"
              : item.label
          }}
        </div>
      </div>
    </div>

    <!-- Detalles de la solicitud -->
    <div class="p-field">
      <p class="text-orange-400">Nombre del colaborador</p>
      <p>
        {{ collaborator | capitalize }}
      </p>

      <div class="flex flex-column gap-5">
        <div>
          <p class="text-orange-400">Inicio de vacaciones</p>
          <p>{{ dateStart }}</p>
        </div>

        <div>
          <p class="text-orange-400">Fin de vacaciones</p>
          <p>{{ dateEnd }}</p>
        </div>
      </div>

      <p class="text-orange-400">Tipo de vacaciones</p>
      <p>
        {{ typeVacationName | capitalize }}
      </p>

      <p class="text-orange-400">Mensaje de administración</p>
      <p>
        {{
          adminMessage == null
            ? "No cuenta con descripción de solicitud."
            : adminMessage
        }}
      </p>
    </div>

    <!-- Mensaje de Colaborador -->
    <div class="p-field mt-4">
      <p class="text-orange-400">Mensaje</p>

      <div
        class="textarea-container"
        *ngIf="showTextarea; else collaboratorMessageText"
      >
        <textarea
          id="collaboratorMessage"
          rows="5"
          [(ngModel)]="collaboratorMessage"
          placeholder="Escriba su mensaje aquí..."
          maxlength="200"
        ></textarea>
        <small>200/{{ collaboratorMessage.length || 0 }}</small>
      </div>
      <ng-template #collaboratorMessageText>
        <p>
          {{
            collaboratorMessage
              ? collaboratorMessage
              : "No se cuenta con mensaje de administración."
          }}
        </p>
      </ng-template>
    </div>

    <!-- <div class="p-field" *ngIf="typeVacationId == '4'">
      <div class="file-top">
        <label for="currentFile">Documento para descargar:</label>
        <button
          type="button"
          pButton
          (click)="documentGenerated ? downloadFile() : onDownload()"
          class="btn-download"
          [disabled]="!documentGenerated"
        >
          <i
            class="pi"
            [ngClass]="documentGenerated ? 'pi-check-circle' : 'pi-download'"
          ></i>
          {{ documentGenerated ? selectedFileName : "Descargar formato" }}
        </button>
      </div>
    </div> -->
    <div class="p-field" *ngIf="typeVacationId == '4'">
      <div class="file-top">
        <label for="currentFile">Documento:</label>
        <button
          type="button"
          pButton
          (click)="documentGenerated ? downloadFile() : onDownload()"
          class="btn-download"
        >
          <i
            class="pi"
            [ngClass]="documentGenerated ? 'pi-send' : 'pi-download'"
          ></i>
          {{ documentGenerated ? selectedFileName : "Descargar formato" }}
        </button>
      </div>

      <div
        class="file-container"
        [ngClass]="{ 'disabled-container': !documentGenerated }"
        (dragover)="documentGenerated ? onDragOver($event) : null"
        (dragleave)="documentGenerated ? onDragLeave($event) : null"
        (drop)="documentGenerated ? onDrop($event) : null"
      >
        <div
          class="file-preview"
          (click)="documentGenerated ? openFileUpload('pdf') : null"
        >
          <div class="custom-file-display">
            <div class="custom-file-top">
              <i
                [ngClass]="
                  selectedFileUploadName ? 'pi pi-file-pdf' : 'pi pi-plus-circle'
                "
              ></i>
              <span>{{
                selectedFileUploadName ||
                  (documentGenerated
                    ? "Subir un archivo"
                    : "Genere el documento primero")
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <p-fileUpload
        #pdfUploader
        [accept]="'application/pdf'"
        [maxFileSize]="10000000"
        (onSelect)="onChangeFile($event)"
        [style]="{ display: 'none' }"
        [disabled]="!documentGenerated"
      >
      </p-fileUpload>
    </div>

    <!-- Confirmación -->
    <div class="confirmation" *ngIf="showConfirmation">
      <p-checkbox
        [(ngModel)]="confirmationChecked"
        binary="true"
        inputId="confirmation"
      />
      <label for="confirmation">
        He revisado detalladamente la solicitud
      </label>
    </div>

    <!-- Botones de aprobación / rechazo -->
    <div class="submit-button" *ngIf="showButtons">
      <button
        pButton
        type="button"
        [label]="primaryButtonLabel"
        class="approve-button"
        (click)="onPrimaryButtonClick()"
        [disabled]="validateForm(true)"
      ></button>
      <button
        pButton
        type="button"
        label="RECHAZAR"
        class="reject-button"
        (click)="onRejectClick()"
        [disabled]="validateForm(false)"
      ></button>
    </div>
  </div>
</p-dialog>
